module.exports = __webpack_public_path__ + "static/media/joyable5_preview.f36102ee.jpg";